var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"promotion-trigger-wrapper",attrs:{"pl-3":"","fxsend":""}},[_c('div',{staticClass:"trigger-link green-link bold",attrs:{"data-gtm-event":_vm.dataGTMEvent},domProps:{"innerHTML":_vm._s(_vm.triggerText)},on:{"click":_vm.displayModal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }